import { ComponentProps } from 'react';
import { VariantProps } from 'tailwind-variants';
import { tag } from './variants';

export type TagProps = ComponentProps<'span'> & VariantProps<typeof tag>;
export type TagVariant = VariantProps<typeof tag>['variant'];

function Tag({
  variant = 'primary',
  className,
  children,
  ...props
}: TagProps) {
  return (
    <span {...props} className={tag({ variant, className })}>
      {children}
    </span>
  );
}

export { Tag };
